export class DeviceResolver {
  static mobileWidth() {
    return window.innerWidth < 768;
  }

  static desktopWidth() {
    return !DeviceResolver.mobileWidth();
  }

  static isTablet() {
    return /iPad|Android/i.test(navigator.userAgent) && !DeviceResolver.mobileWidth();
  }

  static isMobile() {
    return /iPhone|iPod|Android/i.test(navigator.userAgent);
  }

  static isMobileOrTablet() {
    return DeviceResolver.isTablet() || DeviceResolver.isMobile();
  }
}